module.exports = __webpack_public_path__ + "img/play-ayuda.bf0690e7.png";